export default function ({ app, store, redirect }) {
  if (store.state.user.isLogged && !store.getters['user/GET_IS_MEDICLUB_MEMBER']) {
    return redirect(app.localePath('/customer/agreements/?redirect=checkout'))
  }
}
